import { AffiliateButton } from "./Affiliate";
import { Reveal } from "./motion";
import { NORD } from "../data/vpns";

export const CtaBanner = ({
  title = "Ready to protect your privacy — and unblock everything?",
  subtitle = "NordVPN is our #1 pick: the fastest, most secure, and most reliable VPN we've tested in 2026. Try it risk-free for 30 days.",
  ctaLabel = "Get NordVPN — 67% Off Today",
  footnote = "30-day money-back guarantee • Works on 10 devices • No logs, audited",
}) => (
  <section className="relative overflow-hidden bg-[#0F172A] grain" data-testid="bottom-cta-banner">
    <div className="hero-grid absolute inset-0" />
    <div className="relative mx-auto max-w-4xl px-6 py-24 text-center lg:px-8">
      <Reveal>
        <h2 className="font-display text-3xl font-black tracking-tighter text-white sm:text-4xl">{title}</h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-300">{subtitle}</p>
        <div className="mt-8 flex justify-center">
          <AffiliateButton href={NORD.link} testId="bottom-banner-cta" className="!px-10 !py-4 !text-base">
            {ctaLabel}
          </AffiliateButton>
        </div>
        <p className="mt-4 text-xs font-medium text-slate-400">{footnote}</p>
      </Reveal>
    </div>
  </section>
);
